import { useQuery } from '@apollo/client';
import { CloudProductDetailView } from '@css-xp/base/entitlement-utils';
import {
  FetchSandboxParentQuery,
  FetchSandboxParentQueryVariables,
  EntitlementDetails,
} from '@css-xp/graphtypes/src/generated-types-new';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import React, { useMemo } from 'react';
import { fetchSandboxParent } from '../queries/fetch-sandbox-parent';
import { isTrialEntitlement } from '../../entitlment-summary-utils';
import './sandbox-parent.scss';

export const SandboxParent = ({
  sandboxParentId,
  entitlement,
}: {
  sandboxParentId: string;
  entitlement: EntitlementDetails;
}) => {
  const { data, loading } = useQuery<FetchSandboxParentQuery, FetchSandboxParentQueryVariables>(fetchSandboxParent, {
    variables: { id: sandboxParentId },
    displayName: 'fetchSandboxParent',
    notifyOnNetworkStatusChange: true,
  });

  const sandboxParentDetails = useMemo(() => {
    return data?.entitlementDetails;
  }, [data]);

  const isFreePlan = useMemo(
    () => (sandboxParentDetails?.edition ? sandboxParentDetails?.edition.includes('Free') : false),
    [sandboxParentDetails]
  );
  const isTrial = useMemo(() => !isFreePlan && isTrialEntitlement(entitlement, false), [isFreePlan, entitlement]);

  if (loading) {
    return (
      <SkeletonLoaderWrapper testId="sandbox-parent-loader">
        <SkeletonLoader width="100px" />
      </SkeletonLoaderWrapper>
    );
  }

  return (
    <div className="sandbox-parent-container">
      <CloudProductDetailView
        productId={sandboxParentDetails?.productId as string}
        entitlementNumber={sandboxParentDetails?.entitlementNumber as string}
        billingStatus={sandboxParentDetails?.billingStatus}
        provisioningStatus={sandboxParentDetails?.provisioningStatus}
        edition={sandboxParentDetails?.edition}
        productName={sandboxParentDetails?.productName}
        trial={isTrial}
      />
    </div>
  );
};
